export const DEFAULT_WORKSPACE = 'default';

export const MAX_WORKSPACES = 10;
